export const INPUT_DATE_PANEL_WIDTH = 560;

export const INPUT_DATE_REFLOW_MEDIA_QUERY = `(max-width: ${INPUT_DATE_PANEL_WIDTH}px)`;
